import { render, staticRenderFns } from "./cancelarSub.vue?vue&type=template&id=ec87c5d6"
import script from "./cancelarSub.vue?vue&type=script&lang=js"
export * from "./cancelarSub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports